<div class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1" id="kt_login">
	<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
		<!--begin::Aside-->
		<div class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside" 
			[ngStyle]="{'background-image': getLoginBackground()}">
			<div *ngIf="headerLogo" class="kt-grid__item">
				<a href="javascript:;" class="kt-login__logo">
					<img [src]="headerLogo" alt="">
				</a>
			</div>
			<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
				<div class="kt-grid__item kt-grid__item--middle">
					<h3 class="kt-login__title">{{ 'AUTH.GENERAL.AUTH_WELCOME_MESSAGE' | translate }}</h3>
					<h4 class="kt-login__subtitle">{{ 'AUTH.GENERAL.AUTH_WELCOME_SUBTITLE' | translate }}</h4>
				</div>
			</div>
			<div class="kt-grid__item">
				<div class="kt-login__info">
					<div class="kt-login__copyright">
						© {{today|date:'yyyy'}} PricewaterhouseCoopers International
					</div>
					<div class="kt-login__menu">
						<a *ngIf="aboutUsConfig.privacy.enabled" 
							(click)="openInformationDialog(aboutUsConfig.privacy.path)" 
							class="kt-link">
							{{ "AUTH.GENERAL.PRIVACY" | translate }}
						</a>
						<a *ngIf="aboutUsConfig.legal.enabled"
							(click)="openInformationDialog(aboutUsConfig.legal.path)"
							class="kt-link">
							{{ "AUTH.GENERAL.LEGAL" | translate }}
						</a>
						<a *ngIf="aboutUsConfig.contact.enabled"
							(click)="openInformationDialog(aboutUsConfig.contact.path)"
							class="kt-link">
							{{ "AUTH.GENERAL.CONTACT" | translate }}
						</a>
					</div>
				</div>
			</div>
		</div>
		<!--begin::Aside-->

		<!--begin::Content-->
		<div class="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper">
			<router-outlet></router-outlet>
		</div>
		<!--end::Content-->
	</div>
</div>
